import React from 'react';
import { cn } from '../../lib/utils';

// Mono eyebrow: "(01) Services", optionally with a live pulsing dot
const Label = ({ index, dot = false, as: Tag = 'span', className, children }) => (
  <Tag className={cn('label inline-flex items-center gap-2.5', className)}>
    {dot && (
      <span className="relative flex size-1.5" aria-hidden="true">
        <span className="absolute inline-flex size-full animate-ping-soft rounded-full bg-brand motion-reduce:animate-none" />
        <span className="relative inline-flex size-1.5 rounded-full bg-brand" />
      </span>
    )}
    {index && <span className="text-brand-ink">({index})</span>}
    {children}
  </Tag>
);

export default Label;
